module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("diGFE"))).then(() => parcelRequire('1iHdE'));